import Joi from 'joi';

const CustomInputData = Joi.object()
  .optional()
  .keys({
    customFlowType: Joi.string()
      .optional()
      .allow(''),
    dpaIntegrationType: Joi.string()
      .optional()
      .allow('')
  })
  .unknown();

export default CustomInputData;
